/**
 * Extra profanity words beyond leo-profanity's built-in en/de dictionaries —
 * ported verbatim from mobile's `src/utility/profanityWords.js`, plus
 * "moron" — flagged live during testing on this panel as slipping through;
 * it's in neither leo-profanity's en dictionary nor mobile's own extra list.
 */
export const extraProfanityWords = [
  // English
  "whore",
  "slut",
  "motherfucker",
  "fucker",
  "bastard",
  "fuck",
  "dick",
  "bitch",
  "cunt",
  "asshole",
  "moron",

  // German
  "scheiße",
  "arschloch",
  "hurensohn",
  "wichser",
  "hure",
  "nutte",
  "schlampe",
  "fotze",
  "pimmel",
  "fick",
  "fick dich",
  "drecksau",
  "drecksack",
  "arschgesicht",
  "pisskopf",

  // Urdu
  "madarchod",
  "bhenchod",
  "chutiya",
  "harami",
  "randi",
  "bharwa",
  "lund",
  "gaand",
  "beghairat",
  "kamina",
  "haraamzada",
  "kutta",
  "gandu",
];
